import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import { Waypoint } from 'react-waypoint';
import { Button } from "@mui/material";
import clsx from "clsx";
import customStyles from "../../../../../assets/styles/customStyles";
import Down from "../../../../Shared/components/Icons/Down";
import Up from "../../../../Shared/components/Icons/Up";

export const Menu = (props) => {
    const { details, loadMore, loadMoreContent, loadMoreTask, handleOpen, handleParentClick, activeId } = props;
    const classes = customStyles();
    const [currentId, setCurrentId] = useState([]);

    const renderTree = (k, nodes) => (
        <li key={`${nodes.catalogueName ? 'catalogue' : 'category'}_${k}`} className={clsx(activeId, classes.parentNode,
            { [classes.nodeOpen]: currentId.find(e => e === `${nodes.catalogueName ? 'catalogue' : 'category'}_${nodes.id}`) })}>
            <NavLink to={"#"} id={`${nodes.catalogueName ? 'catalogue' : 'category'}_${nodes.id}`} className={clsx(classes.nodeLink, classes.bold,
                { [classes.nodeLinkActive]: activeId === `${nodes.catalogueName ? 'catalogue' : 'category'}_${nodes.id}` },
                { [classes.nodeLinkChilds]: nodes.hasCategories || nodes.hasSubCategories })}
                onClick={() => handleNodeClick(nodes.catalogueName ? 'catalogue' : 'category', nodes)}>
                <span className={classes.nodeCustomName}>
                    {nodes.catalogueName || nodes.categoryName}{nodes.categoryName && <>({nodes.categoryPrefix})</>}
                    {(nodes.hasCategories || nodes.hasSubCategories) &&
                        <span className={classes.nodeCustomArrow}>{currentId.find(e => e === `${nodes.catalogueName ? 'catalogue' : 'category'}_${nodes.id}`) ? <Up /> : <Down />}</span>}
                </span>
            </NavLink>
            {Array.isArray(nodes.submenu)
                ? <ul className={classes.parentNodeUl}>{nodes.submenu.map((node, k) => renderTree(k, node))}</ul>
                : null}
        </li>
    );


    const handleNodeClick = (type, nodes) => {
        handleParentClick(nodes.catalogueName ? 'catalogue' : 'category', nodes);
        setTimeout(() => {
            let newSelected = [];
            let selectedIndexC = currentId.indexOf(`${type}_${nodes.id}`);
            if (type === 'category') {
                if (selectedIndexC === -1) {
                    newSelected = newSelected.concat(currentId, `catalogue_${nodes.catalogueId}`);
                }
            }
            const selectedIndex = currentId.indexOf(`${type}_${nodes.id}`);
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(currentId, `${type}_${nodes.id}`);
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(
                    currentId.slice(0, selectedIndex),
                    currentId.slice(selectedIndex + 1),
                );
            }
            setCurrentId(newSelected);
        }, 200)
    }


    return (
        <>
            {
                !loadMore || details === '' ? (
                    <div className={classes.loadMoreCircle}></div>
                ) : (
                    <>
                        {
                            details && details.length > 0 ?
                                details.map((item, key) => renderTree(key, item)) :
                                (
                                    <div className={clsx(classes.textAlignCenter, classes.noResults)}>
                                        <div className={classes.noResultsText}>Start by Creating Catalogue</div>
                                        <Button
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.modalBtn)}
                                            onClick={() => handleOpen()}
                                        >Create New Catalogue</Button>
                                    </div>
                                )
                        }
                    </>
                )
            }
            {
                loadMoreContent &&
                <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
                    setTimeout(function () {
                        loadMoreTask();
                    }, 500);
                }}>
                    <div className={classes.loadMoreCircle}></div>
                </Waypoint>
            }
        </>
    )
}